import React, { useEffect } from 'react';
import { Container, Divider, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import { Header } from 'src/components/Headers';
import { ServiceClientDetails } from 'src/components/ServiceClients';
import { SERVICE_CLIENT_AUTH } from 'src/constants/permissions';
import { useServiceClient } from 'src/hooks';
import { ServiceClient } from 'src/constants/modules/serviceClient';
import { CapitalizeNames } from 'src/utils/capitalize';
import { getVehiclesList } from 'src/modules/serviceClients/helpers';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
}));

export const ServiceClientsDetailsView = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { serviceClientId } = useParams<{ serviceClientId: string }>();
    const { client, getServiceClientById } = useServiceClient();

    useEffect(() => {
        if (serviceClientId) getServiceClientById(serviceClientId);
    }, [serviceClientId]);

    const vehicles = getVehiclesList(client);

    return (
        <Page className={classes.root} title={t('serviceClients.Detail')}>
            <Container maxWidth={false}>
                <Header
                    module={ServiceClient.name}
                    route={ServiceClient.route}
                    crud={{ goBack: true }}
                    permission={SERVICE_CLIENT_AUTH}
                    title={CapitalizeNames(client?.name)}
                />
                <Divider />
                <ServiceClientDetails client={client} vehicles={vehicles} />
            </Container>
        </Page>
    );
};
